import { UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import BFLNote from "./BFLNote";
import { BFLType } from "../../../types/DBTables";
import { bfv_J10 } from "../../../modules/Beräkningsmoduler/BFV_J10";
import DriftOptimeringarSEK from "./DriftOptimeringarSEK";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card, Table } from "react-bootstrap";
import Funktionskontroller from "./Funktionskontroller";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J10 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfv_J10().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const funktionsKontrollerSEK = bm.funktionsKontrollerSEK || [];
  const funktionsKontroller = bm.funktionsKontroller || [];

  const systemText = global.beräkningsflikarText.beskr_BFV_J10;

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          {/* Funktionskontroll för Vattenburet sekundärvärmesystem. Regleravvikelse framledning. */}
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Card>
            <Card.Header>
              <div>Info QW-tal</div>
            </Card.Header>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td>Anläggningens QW- tal (m³ / MWh) - Se vägledning</td>
                  <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(bm.data?.export?.Anläggningens_QWTal)}</td>
                </tr>
                <tr>
                  <td>Riktvärde QW- tal. Ett högt QW- tal kan innebära flödesavgift och ett lågt QW- tal flödespremie från energibolaget.</td>
                  <td>{new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(bm.data?.export?.Riktvärde_QWTal)}</td>
                </tr>
              </tbody>
            </Table>
          </Card>
          <DriftOptimeringarSEK bfName={BFLType.BFV_J10} formHook={formHook} funktionsKontrollerSEK={funktionsKontrollerSEK} />
          <Funktionskontroller bfName={BFLType.BFV_J10} formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default BFV_J10;
